import { Box, Button, Group, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";

const DeleteDistanceFare = ({
  onSuccess,
  listId,
}: {
  onSuccess: any;
  listId: number[];
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleDelete = async () => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<boolean>>(
        "/api/v1/DistanceFare/delete",
        listId,
      );
      if (res && res.success) {
        NotificationExtension.Success("Xóa thành công !");
        setTimeout(() => {
          onSuccess();
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa thiết lập tính lương quãng đường này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
          loading={visible}
          disabled={visible}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteDistanceFare;
